module.exports = ".bg-color{\n  background-color: #F9FAFA;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = main